import * as React from "react";
const SvgFiRrCarMechanic = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-car-mechanic_svg__a)">
      <path
        fill="#062147"
        d="M20.02 9.52A5.01 5.01 0 0 0 15.68 7H8.32a5.01 5.01 0 0 0-4.34 2.52l-2.059 3.6A7 7 0 0 0 1 16.594V18a4 4 0 0 0 2 3.463V22a2 2 0 0 0 4 0h10a2 2 0 0 0 4 0v-.537A4 4 0 0 0 23 18v-1.406a7 7 0 0 0-.923-3.474zm-14.3.992A3.01 3.01 0 0 1 8.321 9h7.358a3 3 0 0 1 2.6 1.512L20.277 14H3.723zM21 18a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-1.406q0-.298.036-.594H5v1a1 1 0 1 0 2 0v-1h10v1a1 1 0 0 0 2 0v-1h1.964q.036.295.036.594zm2.493-13.351A3.015 3.015 0 0 1 18.167 4H5.845a3.015 3.015 0 0 1-5.326.649C0 3.717 1.926 4.061 2.012 4a1 1 0 0 0 0-2h-1C.34 2 .387 1.552.52 1.351A3.015 3.015 0 0 1 5.845 2h12.322a3.015 3.015 0 0 1 5.326-.649c.524.932-1.407.588-1.493.649a1 1 0 1 0 0 2h1c.673 0 .625.448.493.649"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-car-mechanic_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCarMechanic;
